"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var SubModule_1 = require("../SubModule");

var Restrictions_1 = require("./Restrictions");

var procedures_1 = require("../../../procedures");

var types_1 = require("../../../types");

var PolymathError_1 = require("../../../PolymathError");
/**
 * Namespace that handles all Transfer related functionality
 */


var Transfers =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Transfers, _SubModule_1$SubModul);

  /**
   * Create a new Transfers instance
   */
  function Transfers(securityToken, context) {
    var _this;

    _classCallCheck(this, Transfers);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Transfers).call(this, securityToken, context));
    /**
     * Generate a signature string based on dynamic KYC data. This data can be used to:
     *
     * - Check if a transfer can be made (using `canTransfer`) with different KYC data than is currently present
     * - Actually make a transfer (using `transfer`) with different KYC data than is currently present (in this case, the existing KYC data will be overwritten)
     *
     * The signature can be generated by a third party other than the issuer. The signing wallet should have permission to modify KYC data (via the Tokenholders Administrator role)
     * Otherwise, the new data will be disregarded
     *
     * **Note that, when supplying KYC data for signing, ALL investor entries should be supplied (even those that remain the same)**
     *
     * @param args.kycData - new KYC data array to sign
     * @param args.validFrom - date from which this signature is valid
     * @param args.validTo - date until which this signature is valid
     */

    _this.signKycData = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var context, securityToken, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context = this.context, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                procedure = new procedures_1.SignTransferData(Object.assign({
                  symbol: symbol
                }, args), context);
                return _context.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Transfer an amount of Security Tokens to a specified address
     *
     * @param args.to - address that will receive the tokens
     * @param args.amount - amount of tokens to be transferred
     * @param args.data - optional data to be submitted alongside the transfer
     * @param args.from - optional address from which to transfer tokens. Defaults to the current wallet
     */


    _this.transfer = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var symbol, to, amount, data, from, procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                symbol = this.securityToken.symbol;
                to = args.to, amount = args.amount, data = args.data, from = args.from;
                procedure = new procedures_1.TransferSecurityTokens({
                  symbol: symbol,
                  to: to,
                  amount: amount,
                  data: data,
                  from: from
                }, this.context);
                return _context2.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Retrieve whether the transfer of tokens is frozen or not
     * Can be modified with `freeze` and `unfreeze`
     */


    _this.frozen = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var contractWrappers, securityToken, symbol, tokenInstance;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                _context3.prev = 2;
                _context3.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                tokenInstance = _context3.sent;
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                return _context3.abrupt("return", tokenInstance.transfersFrozen());

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));
    };
    /**
     * Freeze transfers of the security token
     */


    _this.freeze = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.ToggleFreezeTransfers({
                  symbol: symbol,
                  freeze: true
                }, this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };
    /**
     * Validate if a transfer of Security Tokens can be performed. This takes all present transfer restrictions into account
     *
     * @param args.to - address that will receive the tokens
     * @param args.value - amount of tokens to be transferred
     * @param args.data - optional data to be submitted alongside the transfer
     * @param args.from - optional address from which to transfer tokens. Defaults to the current wallet
     */


    _this.canTransfer = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var to, from, value, data, symbol, tokenFactory, securityToken, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                to = args.to, from = args.from, value = args.value, data = args.data;
                symbol = this.securityToken.symbol;
                tokenFactory = this.context.contractWrappers.tokenFactory;
                _context5.next = 5;
                return tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context5.sent;

                if (!from) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 9;
                return securityToken.canTransferFrom({
                  from: from,
                  to: to,
                  value: value,
                  data: data
                });

              case 9:
                result = _context5.sent;
                _context5.next = 15;
                break;

              case 12:
                _context5.next = 14;
                return securityToken.canTransfer({
                  to: to,
                  value: value,
                  data: data
                });

              case 14:
                result = _context5.sent;

              case 15:
                return _context5.abrupt("return", {
                  status: this.getStatusCode(result.statusCode),
                  reason: result.reasonCode
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };

    _this.getStatusCode = function (statusCode) {
      var status;

      if (statusCode === contract_wrappers_1.TransferStatusCode.TransferFailure) {
        status = types_1.TransferStatusCode.TransferFailure;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.TransferSuccess) {
        status = types_1.TransferStatusCode.TransferSuccess;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.InsufficientBalance) {
        status = types_1.TransferStatusCode.InsufficientBalance;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.InsufficientAllowance) {
        status = types_1.TransferStatusCode.InsufficientAllowance;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.TransfersHalted) {
        status = types_1.TransferStatusCode.TransfersHalted;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.FundsLocked) {
        status = types_1.TransferStatusCode.FundsLocked;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.InvalidSender) {
        status = types_1.TransferStatusCode.InvalidSender;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.InvalidReceiver) {
        status = types_1.TransferStatusCode.InvalidReceiver;
      } else if (statusCode === contract_wrappers_1.TransferStatusCode.InvalidOperator) {
        status = types_1.TransferStatusCode.InvalidOperator;
      } else {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.FatalError,
          message: "Status code ".concat(statusCode, " not supported")
        });
      }

      return status;
    };
    /**
     * Unfreeze transfers of the security token
     */


    _this.unfreeze = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.ToggleFreezeTransfers({
                  symbol: symbol,
                  freeze: false
                }, this.context);
                return _context6.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    };

    _this.restrictions = new Restrictions_1.Restrictions(securityToken, context);
    return _this;
  }

  return Transfers;
}(SubModule_1.SubModule);

exports.Transfers = Transfers;